export default __webpack_public_path__ + "5c0004e72607ba9f8a7142d5b49ee016.svg";